/* eslint-disable */
export function toggleNav() {
  let triggers      = $("body").find('[data-target]');
  let classTriggers = [];

  //overlay click closes menu
  $('.navigation_navbar .overlay').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $('.navigation_navbar').removeClass('open');
    // console.log('re-enable scroll on slide');
    $('.navigation_navbar-slide').removeClass('overflow-hidden');
    // console.log('re-enable scroll on body');
    $('body').removeClass('overflow-hidden');
    // $('.submenu-prestations-container.open').removeClass('open');
    $('.submenu-container.open').removeClass('open');
    $("body").find('.submenu-open').removeClass('submenu-open');
    $("body").find('.subsubmenu-open').removeClass('subsubmenu-open');
  });
  $(triggers).each(function(i,trigger) {
    $(trigger).on('click touchend', function (e) {
    // $(trigger).on('click touch', function (e) {
    // $(trigger).click(function (e) {
      e.preventDefault();
      let classTrigger = $(trigger).attr('data-target');
      classTriggers.push(classTrigger);
      let target;

      if(classTrigger.indexOf("subsubmenu") != -1) { //toggle sub sub menu

        resizeSubSubMenu();
        // if($('.submenu-competences-toggle').is(':visible')){
        if($('.'+classTrigger.replace('container', 'toggle')).is(':visible')){

          mainmenu.toggleClass('subsubmenu-open');

          let newContainerHeight = Math.max(document.documentElement.clientHeight, window.innerHeight) + 0;

          if(!mainmenu.hasClass('subsubmenu-open')) {
            //close subsubmenu -> scroll to top of submenu
            let newsubsubmenuHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight) - ($('.'+classTrigger).closest('.submenu-container').scrollTop() + $('.'+classTrigger).closest('.subitem.has-submenu').position().top) - 50 - 0);
            if(newsubsubmenuHeight < 160) newsubsubmenuHeight = 160;
            $('.'+classTrigger).css('max-height', newsubsubmenuHeight + "px");

            $('.'+classTrigger).closest('.submenu-container').animate({
              scrollTop: 0
            }, 400).css('max-height', newContainerHeight).css('min-height', newContainerHeight);
          } else {
            //open subsubmenu
            // subsubmenu.css('max-height', (subsubmenu.get(0).scrollHeight + 75 + 150) + "px");
            $('.'+classTrigger).css('max-height', ($('.'+classTrigger).get(0).scrollHeight + 75 + 150) + "px");
            //open subsubmenu -> scroll to top of subsubmenu
            $('.'+classTrigger).closest('.submenu-container').animate({
              scrollTop: $('.'+classTrigger).closest('li.subitem.has-submenu').position().top + 75
            }, 400).css('max-height', newContainerHeight).css('min-height', newContainerHeight);
          }

        }

        //get target
        target = $("body").find('.' + classTrigger);

      }  else if(classTrigger.indexOf("submenu") != -1) { //toggle sub menu

        //toggle parent
        $(this).parents('.' + classTriggers[0]).toggleClass('submenu-open');
        //get target
        target = $("body").find('.' + classTrigger);

        if($(target).hasClass('open')) { //submenu will close
          //enable scroll menu when submenu is closed
          // console.log('re-enable scroll on slide');
          $('.navigation_navbar-slide').removeClass('overflow-hidden');
        } else { //submenu will open
          //disable scroll menu while submenu is opened
          if (!window.matchMedia("(min-width: 1280px)").matches) {
            // console.log('disable scroll on slide');
            $('.navigation_navbar-slide').addClass('overflow-hidden');
          }
        }
      } else { //toggle main menu

        //get target
        target = $(this).parents('.' + classTrigger);

        if($(target).hasClass('open')) { //will be closed
          $("body").find('.submenu-open').removeClass('submenu-open'); //close submenu if opened
          // $('.submenu-prestations-container.open').removeClass('open');  //close submenu if opened
          // $('.submenu-competences-container.open').removeClass('open');  //close subsubmenu if opened
          $('.submenu-container.open').removeClass('open');  //close submenu if opened
          $('.subsubmenu-container.open').removeClass('open');  //close subsubmenu if opened
          $("body").find('.subsubmenu-open').removeClass('subsubmenu-open'); //close subsubmenu if opened
          // $('.submenu-prestations-container').animate({

          // if($('.submenu-prestations-container').length) {
          if($('.submenu-container').length) {
            $('.submenu-container').each(function(i,el){
              if($(el).find('.subitem.has-submenu').length) {
                $(el).animate({
                  scrollTop: 0
                }, 400);
                // let subsubmenuHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight) - ($('.submenu-prestations-container').scrollTop() + $('.subitem.has-submenu').position().top) - 50 - 0);
                let subsubmenuHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight) - ($(el).scrollTop() + $(el).find('.subitem.has-submenu').position().top) - 50 - 0);
                if(subsubmenuHeight < 160) subsubmenuHeight = 160;
                $(el).find('.subsubmenu-container').css('max-height', subsubmenuHeight);
              }
            });
            //re-enable scroll content in menu
            // console.log('re-enable scroll on slide');
            $('.navigation_navbar-slide').removeClass('overflow-hidden');
          }
          //re-enable scroll content
          // console.log('re-enable scroll on body');
          $('body').removeClass('overflow-hidden');
        } else {
          setTimeout(function(){
            resizeSubSubMenu();
          }, 500);
          if (!window.matchMedia("(min-width: 1280px)").matches) {
            // console.log('disable scroll on body');
            $('body').addClass('overflow-hidden');
          }
        }
        //resizeSubSubMenu

      }

      $(target).toggleClass('open');
      // console.log(triggers);
    });
  });

  let mainmenu = $('header .navigation_navbar');
  // let submenu = mainmenu.find('.submenu');
  // let subsubmenu = mainmenu.find('.subsubmenu');

  // setTimeout(function(){
  //
  //   if($('.subsubmenu').length) {
  //     // let subsubmenuH = ($(window).height() - ($('.submenu-prestations-container').scrollTop() + $('.subitem.has-submenu').position().top) - 50 - 0);
  //     // if(subsubmenuH < 160) subsubmenuH = 160;
  //     // ($(window).height() - ($('.submenu-prestations-container').scrollTop() + $('.subitem.has-submenu').position().top) - 75);
  //
  //     // console.log('subsubmenuH', subsubmenuH);
  //     // $('.submenu-competences-container').css('max-height', subsubmenuH).css('min-height', subsubmenuH);
  //   }
  //   if(mainmenu.length && subsubmenu.length) {
  //     resizeSubSubMenu();
  //   }
  // }, 1500);


  function resizeSubSubMenu(){

    // if(mainmenu.length && subsubmenu.length) {
    if(mainmenu.length) {
      // subsubmenu.css('max-height', $(window).height() - ($('.subsubmenu').offset().top+$('.submenu-prestations-container').scrollTop() - 50));
      // let newHeight = $('.submenu-prestations-container').height() - $('.submenu-prestations-container li.subitem.has-submenu').offset().top;

      // let newHeight = $(window).height() - $('.subitem.has-submenu').position().top + 25;
      // console.log('resizeSubSubMenu $(window).height()', $(window).height());
      // console.log('resizeSubSubMenu window.innerHeight', window.innerHeight);
      // console.log('resizeSubSubMenu document.documentElement.clientHeight', document.documentElement.clientHeight);
      // console.log('resizeSubSubMenu $(submenu-prestations-container).scrollTop()', $('.submenu-prestations-container').scrollTop());
      // console.log('resizeSubSubMenu $(.subitem.has-submenu).position().top', $('.subitem.has-submenu').position().top);

      if($('.submenu-container').length) {
        $('.submenu-container').each(function(i,el){
          // let newHeight = (Math.min($(window).height(), window.innerHeight) - ($('.submenu-prestations-container').scrollTop() + $('.subitem.has-submenu').position().top) - 0 - 0);
          // console.log('resizeSubSubMenu newHeight', newHeight);

          // if(subsubmenu.hasClass('open')) {
          if($(el).find('.subsubmenu-container').length) {
            let newHeight = (Math.min($(window).height(), window.innerHeight) - ($(el).scrollTop() + $(el).find('.subitem.has-submenu').position().top) - 0 - 0);
            if(newHeight < 160) newHeight = 160;

            if($(el).find('.subsubmenu-container').hasClass('open')) {
              //keep subsubmenu open
              // subsubmenu.css('max-height', (subsubmenu.get(0).scrollHeight + 75 + 150) + "px");
              $(el).find('.subsubmenu-container').css('max-height', ($(el).get(0).scrollHeight + 75 + 150) + "px");
            } else {
              // let newsubsubmenuHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight) - ($('.submenu-prestations-container').scrollTop() + $('.subitem.has-submenu').position().top) - 50 - 0);
              let newsubsubmenuHeight = (Math.max(document.documentElement.clientHeight, window.innerHeight) - ($(el).scrollTop() + $(el).find('.subitem.has-submenu').position().top) - 50 - 0);
              if(newsubsubmenuHeight < 160) newsubsubmenuHeight = 160;
              // subsubmenu.css('max-height', newsubsubmenuHeight + "px").css('min-height', newsubsubmenuHeight + "px");
              $(el).find('.subsubmenu-container').css('max-height', newsubsubmenuHeight + "px").css('min-height', newsubsubmenuHeight + "px");
              let newContainerHeight = Math.max(document.documentElement.clientHeight, window.innerHeight) + 0;
              // $('.submenu-prestations-container').animate({
                $(el).animate({
                  scrollTop: 0
                }, 400).css('max-height', newContainerHeight).css('min-height', newContainerHeight);
                if (window.matchMedia("(min-height: 568px)").matches && (newHeight > $(el).find('.subsubmenu-container').get(0).scrollHeight)) {
                // if (window.matchMedia("(min-height: 870px)").matches && newHeight > $(el).get(0).scrollHeight) {
                  //collapsible not needed
                  // console.log('resizeSubSubMenu collapsible not needed');
                  // $('.submenu-competences-toggle').hide();
                  $(el).find('.subsubmenu-toggle').hide();
                  // subsubmenu.css('min-height', '');
                  $(el).find('.subsubmenu-container').css('min-height', '');
                } else {
                  // console.log('resizeSubSubMenu collapsible needed');
                  // $('.submenu-competences-toggle').show();
                  $(el).find('.subsubmenu-toggle').show();
                }
                // subsubmenu.css('max-height', newHeight);
                $(el).find('.subsubmenu-container').css('max-height', newHeight);
              }
          }
        });
      }
      // $('.submenu-prestations-container').css('max-height', Math.max(document.documentElement.clientHeight, window.innerHeight) + 0).css('min-height', Math.max(document.documentElement.clientHeight, window.innerHeight) + 0);
      // $('.submenu-prestations-container').css('max-height', Math.max(document.documentElement.clientHeight, window.innerHeight));
      //clean for desktop menu
      if (window.matchMedia("(min-width: 1280px)").matches) {
        // $('.submenu-competences-container').css('min-height', '').css('max-height', '');
        // $('.submenu-prestations-container').css('min-height', '').css('max-height', '');
        if($('.submenu-container').length) $('.submenu-container').css('min-height', '').css('max-height', '');
        if($('.subsubmenu-container').length) $('.subsubmenu-container').css('min-height', '').css('max-height', '');
        // console.log('re-enable scroll on slide');
        $('.navigation_navbar-slide').removeClass('overflow-hidden');
        // console.log('re-enable scroll on body');
        $('body').removeClass('overflow-hidden');
      }
    }
  }

  $(window).on('resize', function(e){

    if (window.matchMedia("(min-width: 1280px)").matches) {
      //desktop --> close menu
      $("body").find('.subsubmenu-open').removeClass('subsubmenu-open');
      $("body").find('.submenu-open').removeClass('submenu-open');
      $('.navigation_navbar.open').removeClass('open');
      $('.navigation_navbar .open').removeClass('open');
      // if($('.submenu-competences-container').length) $('.submenu-competences-container').css('min-height', '').css('max-height', '');
      // if($('.submenu-prestations-container').length) $('.submenu-prestations-container').css('min-height', '').css('max-height', '');
      if($('.submenu-container').length) $('.submenu-container').css('min-height', '').css('max-height', '');
      if($('.subsubmenu-container').length) $('.subsubmenu-container').css('min-height', '').css('max-height', '');
    } else {
      setTimeout(function(){
        resizeSubSubMenu();
      }, 500);
    }

  });


}

function hideScroll(scroll, seletor){
  if ($(scroll).scrollTop() > 50) {
    if (!seletor.hasClass('hidden'))
      seletor.addClass('hidden');
  } else {
    if (seletor.hasClass('hidden'))
      seletor.removeClass('hidden');
  }
}

export function toggleTextScroll() {
  let logo_text = $('.navigation_navbar-normal .logo-text-container');

  // hideScroll($(window), logo_text);
  // $(window).scroll(function () {
  //   hideScroll($(window), logo_text);
  // });
}

export function changelogoColor() {
  if($('.block--bg-primary').length > 0){
    let $window   = $(window),
        logoColor = $('#color .logo'),
        logoWhite = $('#white .logo'),
        margeTop  = 90,
        bgTop     = $('.block--bg-primary').offset().top - margeTop,
        bgBottom  = $('.block--bg-primary').offset().top + $('.block--bg-primary').height() - margeTop;

    $window.scroll(function () {
      if ($window.scrollTop() > bgTop && $window.scrollTop() < bgBottom) {
        if (!logoColor.hasClass('hidden'))
        logoColor.addClass('hidden');
        logoWhite.removeClass('hidden');
      } else {
        if (logoColor.hasClass('hidden'))
        logoColor.removeClass('hidden');
        logoWhite.addClass('hidden');
      }
    });
  }
}


export function toggleGalaxyMenu() {

  let $window   = $(window),
      $body     = $(document.body),
      menu      = $('.navigation_navbar-normal');

  //init
  $body.addClass('is-not-scrolled');
  if (window.matchMedia("(min-width: 1280px)").matches) { //desktop
    menu.addClass('open');
  }

  //scroll event
  $window.scroll(function () {

    if (window.matchMedia("(min-width: 1280px)").matches) { //desktop
      if ($window.scrollTop() > 150) { //scrolled
        $body.removeClass('is-not-scrolled').addClass('is-scrolled');
        menu.addClass('open');
      } else { //not scrolled
        $body.removeClass('is-scrolled').addClass('is-not-scrolled');
        menu.removeClass('open');
      }
    }

  });

}


const menuNavigation = () => {
  toggleSubMenu();
};

const toggleSubMenus = () => {


  if (!window.matchMedia("(min-width: 1280px)").matches) { //mobile

    // $('nav.')
    const allFocusableElements = $(document.body).find(
      'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary, [tabindex^="0"], [tabindex^="1"], [tabindex^="2"], [tabindex^="3"], [tabindex^="4"], [tabindex^="5"], [tabindex^="6"], [tabindex^="7"], [tabindex^="8"], [tabindex^="9"]'
    );
    allFocusableElements.each(function(i,el){
      $(el).on('focus', function(e){
        if(!$(e.target).hasClass('hamburger-container') && $(e.target).closest('nav').length && !$(e.target).closest('nav').hasClass('open')) {
          // if()allFocusableElements.get(1).focus();
          // console.log('focus in menu but menu is not open');
        }
        // if($(e.target).hasClass(''))
        // console.log('focused event', e, $(e.target).attr('class'), $(e.target).attr('text'), e.target);
      });
    });

    const firstLinks = $('.skipLink, .menu.navigation_navbar-normal > .logo-text:visible a:visible');
    // console.log('firstLinks', firstLinks);
    firstLinks.each(function(i,el){
      $(el).attr('tabindex', i+1);
    });
    $('.hamburger-container').attr('tabindex', firstLinks.length).on('keydown', function(e){
      if(e.keyCode === 9 && !e.shiftKey && !$(e.target).closest('nav').hasClass('open')) {
        e.preventDefault();
        //if tab pressed -> skip entire menu to go to content first focusable element
        $(e.target).blur();
        // const firstFocussableElement =
        // console.log(allFocusableElements.not(firstLinks).not('.hamburger-container').filter(':visible'));
        // $('#main').find(
        //   'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary, [tabindex^="0"], [tabindex^="1"], [tabindex^="2"], [tabindex^="3"], [tabindex^="4"], [tabindex^="5"], [tabindex^="6"], [tabindex^="7"], [tabindex^="8"], [tabindex^="9"]'
        // ).get(0).focus();
        const contentLinks = $('#main').find(
          'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary, [tabindex^="0"], [tabindex^="1"], [tabindex^="2"], [tabindex^="3"], [tabindex^="4"], [tabindex^="5"], [tabindex^="6"], [tabindex^="7"], [tabindex^="8"], [tabindex^="9"]'
        ).filter(':visible');
        // console.log('contentLinks', contentLinks);
        contentLinks.on('keydown', function(e){ //intercept shift+tab -> return to nav check if open
          if(e.keyCode === 9 && e.shiftKey) {
            e.preventDefault();
            $('.hamburger-container').get(0).focus();
          }
        });
        contentLinks.get(0).focus();
        // .get(0).focus();
        // allFocusableElements.not(firstLinks).not('.hamburger-container').filter(':visible').eq(0)
      }
    });

    $('.hamburger-container').attr('tabindex', firstLinks.length).on('click touchend', function(e){
    // $('.hamburger-container').attr('tabindex', firstLinks.length).on('click', function(e){
      if(e.clientX == 0) {
        if($(e.target).closest('nav').hasClass('open')) {
          // console.log('click with keyboard');
          $('.navigation_navbar-top .menu > li > a, .navigation_navbar-top .menu > li > button').filter(':visible').get(0).focus();
          //todo trap in current menu mobile
          $('.navigation_navbar-bottom a').filter(':visible').last().on('keydown.accessibility', function(e){
            if(e.keyCode === 9 && !e.shiftKey) {
              //go back to current menu first link
              // console.log('go back to current menu first link');
              e.preventDefault();
              $('.navigation_navbar-top .menu > li > a').get(0).focus();
            }
          });
          $('.navigation_navbar-top > .menu > li > a').filter(':visible').first().on('keydown.accessibility', function(e){
            if(e.keyCode === 9 && e.shiftKey) {
              //go back to current menu first link
              // console.log('go back to current menu last link');
              e.preventDefault();
              $('.navigation_navbar-bottom a:visible').last().get(0).focus();
            }
          });
          // console.log('top level menu', $('.navigation_navbar-top > .menu > li').find('> a, > button').filter(':visible'));
          $('.navigation_navbar-top > .menu > li').find('> a, > button').filter(':visible').on('keydown.accessibility', function(e){
            if(e.keyCode === 9 && e.shiftKey) {
              let prevBtn = $(e.target).closest('li').prev('li').find('> a:visible, > button:visible');
              if(prevBtn.length && prevBtn.hasClass('js-subMenu-button')) {
                e.preventDefault();
                prevBtn.get(0).focus();
              }
            }
            //escape -> //go back to hamburger
            if(e.keyCode === 27) {
              $('.hamburger-container').get(0).focus();
            }
          });
        } else {
          // console.log('CLOSE MENU!!');
          //close menu remove events
          // e.preventDefault();
          $('.navigation_navbar-top > .menu > li').find('> a, > button').filter(':visible').off("keydown.accessibility");
          $('.navigation_navbar-top > .menu > li > a').filter(':visible').first().off("keydown.accessibility");
          $('.navigation_navbar-bottom a').filter(':visible').last().off('keydown.accessibility');
        }
      }
    });

  }
  // Open Submenus
  const subMenuBtns = document.querySelectorAll(".js-subMenu-button");
  const btnLists = Array.from(subMenuBtns);

  btnLists.forEach(btn => {
    // btn.addEventListener("click", e => {
    btn.addEventListener("focus", e => {

      // e.preventDefault();
      function skipSubMenuEvent(e) {
        //tab key pressed -> next top level menu
        if (e.keyCode === 9 && e.shiftKey) {
          e.preventDefault();
          let prevBtn = $(e.target).closest('li').prev('li').find('a:visible, button:visible');
          if(prevBtn.length) prevBtn.get(0).focus();
          e.target.removeEventListener("keydown", skipSubMenuEvent);
        }

      }

      function subMenuEvents(e) {
        //tab key pressed -> next top level menu
        if (e.keyCode === 9) {
          if (!e.shiftKey) {
            // console.log('btn removeEventListener subMenuEvents', btn);
            btn.removeEventListener("keydown", subMenuEvents);
            // console.log($(btn).closest('li').next('li').find('a, button'), $(btn).closest('li').next('li').find('a, button').get(0));
            let nextBtn = $(btn).closest('li').next('li').find('a:visible, button:visible');
            if(nextBtn.length) {
              e.preventDefault();
              // console.log('nextBtn addEventListener skipSubMenuEvent', nextBtn);
              nextBtn.get(0).addEventListener("keydown", skipSubMenuEvent);
              nextBtn.get(0).focus();
            } else if(!window.matchMedia("(min-width: 1280px)").matches) {
              if($(btn).hasClass('submenu-toggle')){
                // console.log('toggle !!');
                //open subsubmenu
                // $('.submenu-competences-toggle[tabindex="-1"]').trigger('click');
              }
            }
            if(window.matchMedia("(min-width: 1280px)").matches) {
              closeAllMenu();
            }
          } else {
            // console.log('shift + tab key pressed -> previous top level menu');
            //shift + tab key pressed -> previous top level menu
            let prevBtn = $(btn).closest('li').prev('li').find('a:visible, button:visible');
            if(prevBtn.length) {
              // console.log('focus previous btn');
              e.preventDefault();
              prevBtn.get(0).focus();
              // console.log('prevBtn addEventListener skipSubMenuEvent', prevBtn);
              prevBtn.get(0).addEventListener("keydown", skipSubMenuEvent);
              // console.log('btn removeEventListener subMenuEvents', btn);
              btn.removeEventListener("keydown", subMenuEvents);
            }
            //close sub menu
            if(window.matchMedia("(min-width: 1280px)").matches) {
              closeAllMenu();
            }
          }
        }
        //press enter -> enter sub menu
        if (e.keyCode === 13) {
          e.preventDefault();
          //open submenu
          closeAllMenu();

          const menuTarget = btn.dataset.target;
          // console.log('menuTarget', menuTarget);
          //
          // const subMenus = document.querySelector(".js-subMenu");
          // subMenus.classList.toggle("open");
          //
          const subMenuTargeted = document.querySelector(`.js-subMenu.${menuTarget}`);
          subMenuTargeted.classList.add("open");
          $('nav').addClass('submenu-open');

          //create close buttons
          if(window.matchMedia("(min-width: 1280px)").matches) {
            $(subMenuTargeted).append('<button class="subMenu-close js-close-sub-desk" aria-label="Fermer le sous menu"></button>');
            //create page link
            if($(btn).is('a') && ($(btn).attr('href') != '' || $(btn).attr('href') != '#')) {
              $(subMenuTargeted).find('> ul.menu').prepend($(subMenuTargeted).find('li.item.subitem:first-child').clone().addClass('js-submenu-link-desk'));
              $(subMenuTargeted).find('.js-submenu-link-desk a').attr('href', $(btn).attr('href'));
              $(subMenuTargeted).find('.js-submenu-link-desk span').text('Voir la page');
            }
          } else {
            if($(e.target).hasClass('submenu-toggle')){
              // console.log('toggle submenu!! subMenuTargeted', subMenuTargeted);
              if($(e.target).closest('.submenu-container').length && $(subMenuTargeted).hasClass('open')) {
                //close submenu
                $(subMenuTargeted).removeClass('open');
                $('nav').removeClass('submenu-open');
                //return to previous menu
                // console.log($(e.target).closest('.item').parents('.item').find(' > [data-target="'+menuTarget+'"]'));
                // console.log($(e.target).closest('.item').parents('.item').find(' > [data-target="'+menuTarget+'"]').get(0));

                $(e.target).closest('.item').parents('.item').find(' > [data-target="'+menuTarget+'"]').get(0).focus();

                return;
              }
              if($(e.target).closest('.submenu-container').length == 0 && $(subMenuTargeted).hasClass('open')) {
                $(subMenuTargeted).find('> ul.menu [data-target="'+menuTarget+'"]').on('click', function(e){
                  if(e.clientX == 0) {
                    // e.preventDefault();
                    //close submenu
                    $(subMenuTargeted).removeClass('open');
                    $('nav').removeClass('submenu-open');
                    //return to previous menu
                    $(e.target).closest('.item').parents('.item').find(' > [data-target="'+menuTarget+'"]').get(0).focus();
                  }
                });
              }
            }

          }
          ////////////////////////////
          // Accessibility trap focus
          ////////////////////////////
          // console.log('subMenuTargeted addEventListener trap', subMenuTargeted);
          subMenuTargeted.addEventListener("keydown", trap);

          let focusableElements = $(subMenuTargeted).find(
            'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary, [tabindex^="0"], [tabindex^="1"], [tabindex^="2"], [tabindex^="3"], [tabindex^="4"], [tabindex^="5"], [tabindex^="6"], [tabindex^="7"], [tabindex^="8"], [tabindex^="9"]'
          ).filter(':visible:not([tabindex="-1"])');
          // focusableElements = Array.from(focusableElements);
          // console.log('focusableElements', focusableElements);

          const firstFocussableElement = focusableElements.get(0);
          const lastFocussableElement = focusableElements.get(focusableElements.length - 1);

          // if click made with the keyboard
            // if (e.clientX === 0) {

              if(window.matchMedia("(min-width: 1280px)").matches) {
                //desktop
                // console.log('focus firstFocussableElement', firstFocussableElement);
                firstFocussableElement.focus();
              } else {
                //mobile
                // console.log('focus focusableElements.get(1)', focusableElements.get(1));
                focusableElements.get(1).focus();
              }
            // }

            function trap(event) {
              const activeElement = document.activeElement;
              if (event.keyCode === 9) {
                // shift is not held down
                if (!event.shiftKey) {
                  //is last item?
                  if (activeElement === lastFocussableElement) {
                    //is mobile and last item of submenu?
                    if(!window.matchMedia("(min-width: 1280px)").matches && $(activeElement).closest('li.sub-subitem:last-child').length) {
                      // console.log('LAST IN SUBMENU');
                      // console.log('TRIGGER ACCORDION CLICK');
                      $(activeElement).closest('.submenu-container').find('.subsubmenu-toggle[tabindex="-1"]').trigger('click');
                    }
                    event.preventDefault();
                    firstFocussableElement.focus();
                  } else {
                    //is mobile?
                    if(!window.matchMedia("(min-width: 1280px)").matches){
                      // is first item of submenu ?
                      if($(activeElement).closest('li.sub-subitem:first-child').length) {
                        // console.log('FIRST IN SUBMENU');
                        // console.log('TRIGGER ACCORDION CLICK');
                        if($(activeElement).closest('.subsubmenu').length   && !$(activeElement).closest('.subsubmenu').hasClass('open')) $(activeElement).closest('.submenu-container').find('.subsubmenu-toggle[tabindex="-1"]').trigger('click');
                      }
                    }
                  }

                }
                // shift is held down
                else {
                  if (activeElement === firstFocussableElement) {

                    //is mobile?
                    if(!window.matchMedia("(min-width: 1280px)").matches){
                      // is last item of submenu
                      if($(activeElement).hasClass('submenu-toggle')) {
                        // console.log('FIRST IN LOOP and IS SUBMENU TOGGLE');
                        // console.log('GO TO LAST TRIGGER ACCORDION CLICK');
                        if($(activeElement).closest('.js-subMenu').find('.subsubmenu').length && !$(activeElement).closest('.js-subMenu').find('.subsubmenu').hasClass('open')) $(activeElement).closest('.submenu-container').find('.subsubmenu-toggle[tabindex="-1"]').trigger('click');
                      }
                    }
                    event.preventDefault();
                    lastFocussableElement.focus();
                  } else {

                    if($(activeElement).closest('li.sub-subitem:first-child').length) {
                      // console.log('FIRST IN SUBSUBMENU');
                      // console.log('TRIGGER ACCORDION CLICK TO CLOSE');
                      if($(activeElement).closest('.subsubmenu').length && $(activeElement).closest('.subsubmenu').hasClass('open')) $(activeElement).closest('.submenu-container').find('.subsubmenu-toggle[tabindex="-1"]').trigger('click');
                    }
                  }
                }

              }

              // if enter check the element has close
              else if (event.keyCode === 13) {
                if (activeElement.classList.contains("js-close-sub-desk")) {
                  // console.log('subMenuTargeted removeEventListener trap enter (close button)', subMenuTargeted);
                  subMenuTargeted.removeEventListener("keydown", trap);
                  // focus previous
                  closeAllMenu();
                  btn.focus();
                }
              }
              // If escape cut all and focus previous element.
              else if (event.keyCode === 27) {
                // console.log('subMenuTargeted removeEventListener trap escape', subMenuTargeted);
                subMenuTargeted.removeEventListener("keydown", trap);
                closeAllMenu();
                // focus previous
                btn.focus();
              }
            }
          }
        }
        //intercept keydown
        // console.log('btn addEventListener subMenuEvents', btn);
        btn.addEventListener("keydown", subMenuEvents);

    });
  });

  // // Close Submenus on Mobile
  // const closeBtns = document.querySelectorAll(".js-submenu-close");
  // const closeList = Array.from(closeBtns);
  //
  // closeList.forEach(btn => {
  //   btn.addEventListener("click", e => {
  //     e.preventDefault();
  //     const subMenuPanel = document.querySelector(".subMenus");
  //     const parentSubMenu = btn.closest(".subMenus__listing__item");
  //
  //     parentSubMenu.classList.remove("active");
//     subMenuPanel.classList.remove("active");
  //   });
  // });
  //
  // const closeDesktop = document.querySelectorAll(".js-close-sub-desk");
  // const closeDesktopArray = Array.from(closeDesktop);
  //
  // closeDesktopArray.forEach(closeBtn => {
  //   closeBtn.addEventListener("click", e => {
  //     e.preventDefault();
  //     closeAllMenu();
  //   });
  // });
};


const closeAllMenu = () => {
  // console.log('closeAllMenu');
  // Mob and Desk
  const subMenu = $(".js-subMenu");
  const subMenuActive = $(".js-subMenu.open");

  if (subMenu.length) {
    subMenu.removeClass("open");
  }

  if (subMenuActive.length) {
    subMenuActive.removeClass("open");
    let closeBtn = subMenuActive.find(".subMenu-close");
    if(closeBtn) closeBtn.remove();
    let btnLink = subMenuActive.find(".js-submenu-link-desk");
    if(btnLink) btnLink.remove();
    $('nav').removeClass('submenu-open');
  }
};

export { toggleSubMenus, closeAllMenu };



// WEBPACK FOOTER //
// ./scripts/components/navbar.js